import { render } from "./fittingTable.vue?vue&type=template&id=08465f6e"
import script from "./fittingTable.vue?vue&type=script&lang=js"
export * from "./fittingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__